import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../../../components/form-elements/Checkbox';
export default class ReturnNotificationCheckbox extends PureComponent {
  state = {
    text: ''
  };
  /* eslint-disable */
  componentDidMount() {
    const {
      type
    } = this.props;
    const text = I18n.t(`pages.account.return_order.refund_notifications.${type}`);
    const enrichedText = this.enrich(text);
    this.setState({
      text: enrichedText
    });
  }
  /* eslint-enable */
  getContentEl = contentEl => {
    if (!contentEl) {
      return;
    }
    const interactiveLinkClassNames = ['interactive-link', 'text-primary'];
    const links = Array.from(contentEl.querySelectorAll('[data-type]'));
    links.forEach(link => interactiveLinkClassNames.forEach(className => link.classList.add(className)));
  };
  enrich = text => /*#__PURE__*/React.createElement("span", {
    ref: this.getContentEl,
    dangerouslySetInnerHTML: {
      __html: text
    },
    onClick: this.openModal
  });
  openModal = e => {
    const type = e.target.getAttribute('data-type');
    const {
      modalUrl,
      openModal
    } = this.props;
    if (!type) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    openModal(modalUrl);
  };
  render() {
    const {
      isChecked,
      onClick,
      type
    } = this.props;
    const {
      text
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "order-return__compliance-notification",
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        onClick(type);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "order-return__compliance-notification-info"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
      isChecked: isChecked
    })), /*#__PURE__*/React.createElement("div", null, text))));
  }
}
ReturnNotificationCheckbox.propTypes = {
  type: PropTypes.string,
  modalUrl: PropTypes.string,
  isChecked: PropTypes.bool,
  openModal: PropTypes.func,
  onClick: PropTypes.func
};